/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * News list item component
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { FC, memo } from 'react';

import { LinkBlock } from '@/main/components/common';
import { ROUTE_NEWS_ID, RoutePath } from '@/main/routes/constants/routesConstants';

import { NewsItemContainerStyled } from '../styled/NewsListStyled';
import { INewsListItem } from '../types';

interface INewsListItemProps {
    itemData: INewsListItem;
    selected?: boolean;
}

const NewsListItem: FC<INewsListItemProps> = ({ itemData, selected = false }) => {
    const { id, title, link } = itemData;

    return (
        <NewsItemContainerStyled $selected={selected}>
            <LinkBlock
                isExternalUrl={!!link}
                target={link ? '_blank' : '_self'}
                url={link ? link : RoutePath.newsId.replace(ROUTE_NEWS_ID, String(id))}
            >
                {title}
            </LinkBlock>
        </NewsItemContainerStyled>
    );
};

export default memo(NewsListItem);
